<template>
  <transition name="products">
    <div class="product-swipe">
      <Title :class="titleClasses">
        {{ title }}
      </Title>
      <Slides
        :pack="pick"
      />
      <Button
        v-if="!pick"
        @click.native="pickSize"
      >
        Kies deze maat
      </Button>
    </div>
  </transition>
</template>

<script>
import Slides from './Slides'
import Title from './Title'
import Button from './Button'
import { trackIntroPick } from '@/utils/track'

export default {
  name: 'ProductSwipe',
  data () {
    return {
      pick: false,
      title: 'Yes, die trui is er! Je hebt vier maten besteld, kies er eentje.',
      switch: false,
      fade: false
    }
  },
  components: {
    Slides,
    Title,
    Button
  },
  methods: {
    pickSize () {
      this.pick = true
      trackIntroPick()
      setTimeout(() => this.$emit('pick'), 1000)
      setTimeout(this.switchTitle, 1500)
    },
    switchTitle () {
      this.switch = true
      this.title = 'Oké, dan sturen we de rest weer terug.'
      setTimeout(this.packAway, 1000)
    },
    packAway () {
      this.fade = true
      this.$emit('pack')
    }
  },
  computed: {
    productSwipeClasses () {
      return {
        'product-swipe': true,
        'product-swipe-pick': this.pick,
        'product-swipe-fade': this.fade
      }
    },
    titleClasses () {
      return {
        'away': this.pick,
        'switch': this.switch
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.products-enter-active {
  transition: all 2.5s cubic-bezier(.19,1,.22,1) 1.25s;
  transition-property: transform, opacity;
  will-change: transform, opacity;
}

.products-enter {
  opacity: 0;
  transform: rotate(-10deg) scale(0.4);
}

.product-swipe {
  width: 320px;
  margin: 0 auto;
  position: absolute;
  top: -20px;
  left: -19px;
  right: -19px;
  z-index: 10;
  text-align: center;

  @media (max-width: 479px) {
    width: 250px;
    left: 0;
    right: 0;
  }
}
</style>
